import {
  ProjectEntity,
  ProjectMemberEntity,
  UserEntity,
} from '../../../../../server-api-hrm.type'
import uniqueArrayById from '../../../../../utils/unique-array-by-id'
import useProjectStore from '../project.store'
import { MenuRefetchSignal } from './project-store'

export const setIsAdmin = (isAdmin: boolean) =>
  useProjectStore.setState({ isAdmin })

export const setIsLeader = (isLeader: boolean) =>
  useProjectStore.setState({ isLeader })

export const setProjectMembers = (
  members: ProjectMemberEntity[],
  type: 'fetch' | 'load-more' | 're-fetch' = 'fetch'
) =>
  useProjectStore.setState(({ members: prev }) => ({
    members:
      type === 'load-more' ? uniqueArrayById([...prev, ...members]) : members,
  }))

export const setCurrentUser = (currentUser: UserEntity) =>
  useProjectStore.setState({ currentUser })

export const setProjectDetail = (projectDetail: ProjectEntity) =>
  useProjectStore.setState({ projectDetail })

export const setMenuRefetchSignal = (
  menuRefetchSignal: MenuRefetchSignal | undefined
) => useProjectStore.setState({ menuRefetchSignal })
